import React from 'react'
import Signup from '../components/Signup'

const SignupPage = () => {
  return (
    <div className=" py-[80px]">
      <Signup />
    </div>
  );
}

export default SignupPage
